import { ReactiveMap } from "@solid-primitives/map"
import type { EntityGraphNode } from "../../lib/core/engine/EntityGraphNode/EntityGraphNode.type"
import type { PlayerId } from "../../lib/core/player/PlayerId"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export type EntityByPlayerIdReactiveMap = ReactiveMap<PlayerId, Array<EntityGraphNode>>

export const useEntityByPlayerIdReactiveMap = createSharedCachedFactory((
  // engine: Engine
): EntityByPlayerIdReactiveMap => {
  const map = new ReactiveMap<PlayerId, Array<EntityGraphNode>>()
  return map
})
